/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ErroreClientSegnalazioneForm } from '../model/models';
import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface SegnalaErroreClientRequestParams {
    erroreClientSegnalazioneForm: ErroreClientSegnalazioneForm;
}


export interface ErroriClientServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Segnala un batch di errori client (JS non gestiti o submit bloccati dalla validazione).
     * Pubblico, nessuna autenticazione richiesta. Accetta anche Content-Type: text/plain con lo stesso corpo JSON (serve a sendBeacon, che cross-origin con application/json Chrome rifiuta). Risponde sempre 202 senza corpo quando la richiesta e\&#39; sintatticamente valida (anche se il kill-switch civeshub.errori-client.enabled e\&#39; false: in quel caso non scrive nulla). \&#39;errori\&#39; deve contenere da 1 a 20 elementi; un enum sconosciuto, o un elemento null/non-oggetto, scarta solo quell\&#39;elemento. Valori oltre il massimo sono troncati, non rifiutati.
     * @endpoint post /api/v1/errori-client
* @param requestParameters
     */
    segnalaErroreClient(requestParameters: SegnalaErroreClientRequestParams, extraHttpRequestParams?: any): Observable<{}>;

}
